
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"27","viewBox":"0 0 26 27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"13","cy":"13.5","r":"13","fill":"#07193D"}}),_c('path',{attrs:{"d":"M9.75 8.583a1.084 1.084 0 00-1.084 1.084v9.75L13 17.792l4.333 1.625v-9.75a1.085 1.085 0 00-1.083-1.083h-6.5z","fill":"#fff"}})])
          )
        }
      }
    